import { cn } from '../../lib/utils';
import { getKycStatusConfig, getKycTypeLabel } from '../../lib/terminology';

interface KycStatusBadgeProps {
  status: string;
  type?: 'ORIGIN' | 'DESTINATION';
  showTooltip?: boolean;
  submittedAt?: string | Date;
  updatedAt?: string | Date;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export function KycStatusBadge({
  status,
  type,
  showTooltip = false,
  submittedAt,
  updatedAt,
  size = 'md',
  showLabel = true,
}: KycStatusBadgeProps) {
  const config = getKycStatusConfig(status);
  
  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm',
  };

  const formatDate = (date: string | Date) => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const tooltipContent = showTooltip ? (
    <div className="text-xs">
      {type && <p className="font-medium mb-1">KYC de {getKycTypeLabel(type)}</p>}
      {submittedAt && <p>Enviado: {formatDate(submittedAt)}</p>}
      {updatedAt && <p>Atualizado: {formatDate(updatedAt)}</p>}
    </div>
  ) : null;

  return (
    <div className="relative group inline-flex">
      <span
        className={cn(
          'inline-flex items-center gap-1 rounded-full font-medium',
          sizeClasses[size],
          config.bgColor,
          config.color
        )}
      >
        <span className="text-base leading-none">{config.icon}</span>
        {showLabel && <span>{config.label}</span>}
      </span>
      
      {showTooltip && tooltipContent && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-surface-900 border border-surface-700 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50 whitespace-nowrap">
          {tooltipContent}
          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-4 border-transparent border-t-surface-700" />
        </div>
      )}
    </div>
  );
}

export default KycStatusBadge;
